import React, { createContext, useMemo, useState } from "react";
import { VenueGroupConfig } from "../types/VenueGroup";
import { VenueUserConfig } from "../types/VenueUser";

type AppContextType = {
  venueGroupConfig: VenueGroupConfig | null;
  setVenueGroupConfig: React.Dispatch<VenueGroupConfig>;
  venueUserConfig: VenueUserConfig | null;
  setVenueUserConfig: React.Dispatch<VenueUserConfig>;
};

export const AppContext = createContext<AppContextType>({
  venueGroupConfig: null,
  setVenueGroupConfig: () => true,
  venueUserConfig: null,
  setVenueUserConfig: () => true
});

export const AppContextProvider = ({ children }: any) => {
  const [venueGroupConfig, setVenueGroupConfig] =
    useState<VenueGroupConfig | null>(null);
  const [venueUserConfig, setVenueUserConfig] =
    useState<VenueUserConfig | null>(null);

  const contextValue = useMemo(
    () => ({
      venueGroupConfig,
      setVenueGroupConfig,
      venueUserConfig,
      setVenueUserConfig
    }),
    [venueGroupConfig, venueUserConfig]
  );

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};
